/* global ResizeObserver */
import { useEffect, useRef } from 'react'

export const useImageBackground = (aspectRatio, backgroundColor = '#FFEBE7') => {
  const containerRef = useRef(null)

  useEffect(() => {
    const setContainerHeight = () => {
      if (!containerRef.current || !aspectRatio) return
      const resolution = aspectRatio.split(':')
      if (resolution.length !== 2) return
      const ratio = parseFloat(resolution[0]) / parseFloat(resolution[1])
      const containerWidth = containerRef.current.getBoundingClientRect().width
      if (containerWidth) {
        containerRef.current.style.height = `${parseInt(containerWidth / ratio)}px`
        containerRef.current.style.background = backgroundColor
      }
    }

    setContainerHeight()
    const handleResize = () => setContainerHeight()
    window.addEventListener('resize', handleResize)

    let resizeObserver
    if (window.ResizeObserver && containerRef.current) {
      resizeObserver = new ResizeObserver(setContainerHeight)
      resizeObserver.observe(containerRef.current)
    }

    // Lazy load images
    const imgElements = containerRef.current?.querySelectorAll('img[data-url]')
    let intersectionObserver
    if (imgElements && imgElements.length && window.IntersectionObserver) {
      intersectionObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target
            if (img.dataset.url) {
              img.src = img.dataset.url
              // img.removeAttribute('data-url')
              observer.unobserve(img) // stop observing after load
            }
          }
        })
      }, { threshold: 0.05 }) // trigger as soon as visible

      imgElements.forEach(img => intersectionObserver.observe(img))
    } else {
      // fallback: load immediately if no IntersectionObserver
      imgElements.forEach(img => {
        if (img.dataset.url) {
          img.src = img.dataset.url
          img.removeAttribute('data-url')
        }
      })
    }

    return () => {
      window.removeEventListener('resize', handleResize)
      if (resizeObserver) resizeObserver.disconnect()
      if (intersectionObserver) intersectionObserver.disconnect()
    }
  }, [aspectRatio, backgroundColor])

  return containerRef
}



// WEBPACK FOOTER //
// ./src/react-component/Hooks/useImageBackground.js